"use strict";

exports.__esModule = true;
var moment_1 = require("moment");
exports.TIME_FORMAT = 'HH:mm';
exports.WEEK_FORMAT = 'd';
exports.DATE_FORMAT = 'YYYY-MM-DD';
exports.defaultSchedule = {
  extractorId: null,
  interval: 'Daily',
  intervalData: {
    type: 'None'
  },
  nextRunAt: null,
  ownerId: null
};
exports.SCHEDULE_DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'], exports.SCHEDULE_FULL_DAYS = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'], exports.SCHEDULE_TYPES = [{
  label: 'None',
  value: 'None'
}, {
  label: 'Hourly',
  value: 'Hourly'
}, {
  label: 'Daily',
  value: 'Daily'
}, {
  label: 'Weekly',
  value: 'Weekly'
}, {
  label: 'Monthly',
  value: 'Monthly'
}, {
  label: 'Advanced',
  value: 'Cron'
}], exports.CRON_TABS = ['cronMinutes', 'cronHours', 'cronMonthday', 'cronMonth', 'cronWeekday'], exports.MAX_CRON_TABS = {
  cronMinutes: 59,
  cronHours: 23,
  cronMonthday: 31,
  cronMonth: 12,
  cronWeekday: 6
}, exports.MIN_CRON_TABS = {
  cronMinutes: 0,
  cronHours: 0,
  cronMonthday: 1,
  cronMonth: 1,
  cronWeekday: 0
}, exports.CRON_TABS_DESC = {
  cronMinutes: 'Minutes',
  cronHours: 'Hours',
  cronMonthday: 'Day (month)',
  cronMonth: 'Month',
  cronWeekday: 'Day (week)'
}, exports.CRON_DESC_COMMON = [{
  key: '*',
  value: 'any value'
}, {
  key: ',',
  value: 'value list separator'
}, {
  key: '-',
  value: 'range of values'
}, {
  key: '/',
  value: 'step values'
}], exports.CRON_TAG_DESCRIPTIONS = {
  cronMinutes: exports.CRON_DESC_COMMON.concat([{
    key: '0-59',
    value: 'allowed values'
  }]),
  cronHours: exports.CRON_DESC_COMMON.concat([{
    key: '0-23',
    value: 'allowed values'
  }]),
  cronMonthday: exports.CRON_DESC_COMMON.concat([{
    key: '1-31',
    value: 'allowed values'
  }]),
  cronMonth: exports.CRON_DESC_COMMON.concat([{
    key: '1-12',
    value: 'allowed values'
  }, {
    key: 'JAN-DEC',
    value: 'alternative single values'
  }]),
  cronWeekday: exports.CRON_DESC_COMMON.concat([{
    key: '0-6',
    value: 'allowed values'
  }, {
    key: 'SUN-SAT',
    value: 'alternative single values'
  }])
}, exports.CRON_DEFAULT = {
  cronMinutes: '0',
  cronHours: '13',
  cronMonthday: '*',
  cronMonth: '*',
  cronWeekday: 'mon'
}, exports.CRON_ALLOWED_VALUES = {
  cronMonth: {
    jan: true,
    feb: true,
    mar: true,
    apr: true,
    may: true,
    jun: true,
    jul: true,
    aug: true,
    sep: true,
    oct: true,
    nov: true,
    dec: true
  },
  cronWeekday: {
    mon: true,
    tue: true,
    wed: true,
    thu: true,
    fri: true,
    sat: true,
    sun: true
  }
};
function convertToUserTZ(data) {
  if (data) {
    var interval_data = data.intervalData;
    var utc_moment = void 0,
      tz_moment = void 0;
    if (!interval_data) {
      data.intervalData = {
        type: 'Cron',
        startTimestamp: data.nextRunAt,
        interval: data.interval
      };
      var cronValues = data.interval.split(' ');
      data.intervalData.cronMinutes = cronValues[0];
      data.intervalData.cronHours = cronValues[1];
      data.intervalData.cronMonthday = cronValues[2];
      data.intervalData.cronMonth = cronValues[3];
      data.intervalData.cronWeekday = cronValues[4];
      return data;
    }
    switch (interval_data.type) {
      case 'Monthly':
        utc_moment = moment_1["default"](interval_data.monthly_start_date + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
        tz_moment = moment_1["default"](utc_moment);
        tz_moment.add(moment_1["default"]().utcOffset(), 'm');
        interval_data.monthly_start_date = tz_moment.format('YYYY-MM-DD');
        interval_data.time = tz_moment.format('HH:mm');
        break;
      case 'Weekly':
        utc_moment = moment_1["default"](moment_1["default"]().format('YYYY-MM-DD') + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
        tz_moment = moment_1["default"](utc_moment);
        tz_moment.add(moment_1["default"]().utcOffset(), 'm');
        if (utc_moment.dayOfYear() !== tz_moment.dayOfYear()) {
          if (utc_moment.dayOfYear() > tz_moment.dayOfYear()) {
            if (interval_data.week_day === 0) {
              interval_data.week_day = 6;
            } else {
              interval_data.week_day--;
            }
          } else {
            if (interval_data.week_day === 6) {
              interval_data.week_day = 0;
            } else {
              interval_data.week_day++;
            }
          }
        }
        interval_data.time = tz_moment.format('HH:mm');
        break;
      case 'Daily':
        utc_moment = moment_1["default"](moment_1["default"]().format('YYYY-MM-DD') + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
        tz_moment = moment_1["default"](utc_moment);
        tz_moment.add(moment_1["default"]().utcOffset(), 'm');
        interval_data.time = tz_moment.format('HH:mm');
        break;
    }
    data.intervalData = interval_data;
  }
  return data;
}
exports.convertToUserTZ = convertToUserTZ;
function convertToUTC(interval_data) {
  var tz_moment, utc_moment;
  switch (interval_data.type) {
    case 'Monthly':
      tz_moment = moment_1["default"](interval_data.monthly_start_date + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
      utc_moment = tz_moment.clone().utc();
      interval_data.monthly_start_date = utc_moment.format('YYYY-MM-DD');
      interval_data.time = utc_moment.format('HH:mm');
      break;
    case 'Weekly':
      tz_moment = moment_1["default"](moment_1["default"]().format('YYYY-MM-DD') + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
      utc_moment = tz_moment.clone().utc();
      if (tz_moment.dayOfYear() !== utc_moment.dayOfYear()) {
        if (tz_moment.dayOfYear() > utc_moment.dayOfYear()) {
          if (interval_data.week_day === 0) {
            interval_data.week_day = 6;
          } else {
            interval_data.week_day--;
          }
        } else {
          if (interval_data.week_day === 6) {
            interval_data.week_day = 0;
          } else {
            interval_data.week_day++;
          }
        }
      }
      interval_data.time = utc_moment.format('HH:mm');
      break;
    case 'Daily':
      tz_moment = moment_1["default"](moment_1["default"]().format('YYYY-MM-DD') + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
      utc_moment = tz_moment.clone().utc();
      interval_data.time = utc_moment.format('HH:mm');
      break;
  }
  return interval_data;
}
exports.convertToUTC = convertToUTC;
function getIntervalTime(time_string) {
  var split_time_arr = time_string.split(':');
  var minutes = split_time_arr[1].replace(/^[0]+/g, '');
  if (minutes === '') {
    minutes = 0;
  }
  var hours = split_time_arr[0].replace(/^[0]+/g, '');
  if (hours === '') {
    hours = 0;
  }
  return {
    hours: hours,
    minutes: minutes
  };
}
exports.getIntervalTime = getIntervalTime;
function getInterval(interval_data) {
  var split_time = getIntervalTime(interval_data.time);
  var hour = interval_data.type == 'Hourly' ? '*' : split_time.hours;
  var week_day = interval_data.type == 'Weekly' ? interval_data.week_day : '*';
  var day_of_month = interval_data.type == 'Monthly' ? moment_1["default"](interval_data.monthly_start_date).format('D') : '*';
  return split_time.minutes + ' ' + hour + ' ' + day_of_month + ' * ' + week_day;
}
exports.getInterval = getInterval;
function nextMonthDayOccurence(interval_data) {
  var output = moment_1["default"].utc(interval_data.monthly_start_date + ' ' + interval_data.time, 'YYYY-MM-DD HH:mm');
  while (!output.isAfter(moment_1["default"].utc().add(10, 'seconds'))) {
    output.add(1, 'month');
  }
  return output;
}
exports.nextMonthDayOccurence = nextMonthDayOccurence;
function nextWeekDayOccurence(interval_data) {
  var split_time = getIntervalTime(interval_data.time);
  var output = moment_1["default"].utc().weekday(interval_data.week_day).hour(split_time.hours).minutes(split_time.minutes);
  while (!output.isAfter(moment_1["default"].utc().add(10, 'seconds'))) {
    output.add(1, 'week');
  }
  return output;
}
exports.nextWeekDayOccurence = nextWeekDayOccurence;
function nextDayOccurence(interval_data) {
  var split_time = getIntervalTime(interval_data.time);
  var output = moment_1["default"].utc().hour(split_time.hours).minutes(split_time.minutes);
  while (!output.isAfter(moment_1["default"].utc().add(10, 'seconds'))) {
    output.add(1, 'day');
  }
  return output;
}
exports.nextDayOccurence = nextDayOccurence;
function nextHourOccurence(interval_data) {
  var split_time = getIntervalTime(interval_data.time);
  var output = moment_1["default"].utc().hour(split_time.hours).minutes(split_time.minutes);
  while (!output.isAfter(moment_1["default"].utc().add(10, 'seconds'))) {
    output.add(1, 'hour');
  }
  return output;
}
exports.nextHourOccurence = nextHourOccurence;
function getStartTimestamp(interval_data) {
  switch (interval_data.type) {
    case 'Monthly':
      var next_month_day = nextMonthDayOccurence(interval_data);
      return next_month_day.valueOf();
    case 'Weekly':
      var next_week_day = nextWeekDayOccurence(interval_data);
      return next_week_day.valueOf();
    case 'Daily':
      var next_time = nextDayOccurence(interval_data);
      return next_time.valueOf();
    case 'Hourly':
      var next_hour = nextHourOccurence(interval_data);
      return next_hour.valueOf();
    default:
      return null;
  }
}
exports.getStartTimestamp = getStartTimestamp;
function prepareScheduleForSave(extractorId, interval_data) {
  var interval_data_copy = Object.assign({}, interval_data);
  var schedule_updates = {};
  interval_data_copy = convertToUTC(interval_data_copy);
  schedule_updates.extractorId = extractorId;
  schedule_updates.intervalData = interval_data_copy;
  if (!interval_data.interval) {
    schedule_updates.interval = getInterval(interval_data_copy);
  } else {
    schedule_updates.interval = interval_data.interval;
  }
  if (!interval_data.startTimestamp) {
    schedule_updates.startTimestamp = getStartTimestamp(interval_data_copy);
  } else {
    schedule_updates.startTimestamp = interval_data.startTimestamp;
  }
  var new_schedule = Object.assign(exports.defaultSchedule, schedule_updates);
  delete new_schedule.nextRunAt;
  delete new_schedule.ownerId;
  return new_schedule;
}
exports.prepareScheduleForSave = prepareScheduleForSave;
function getHourlyInterval() {
  var intervalData = {};
  intervalData.type = 'Hourly';
  intervalData.time = moment_1["default"].utc().format(exports.TIME_FORMAT);
  intervalData.minutes = Number(getIntervalTime(intervalData.time).minutes);
  return intervalData;
}
exports.getHourlyInterval = getHourlyInterval;
function getDailyInterval() {
  var intervalData = {};
  intervalData.type = 'Daily';
  intervalData.time = moment_1["default"]().format(exports.TIME_FORMAT);
  return intervalData;
}
exports.getDailyInterval = getDailyInterval;
function getWeeklyInterval() {
  var intervalData = {};
  intervalData.type = 'Weekly';
  intervalData.time = moment_1["default"]().format(exports.TIME_FORMAT);
  intervalData.week_day = parseInt(moment_1["default"]().format(exports.WEEK_FORMAT));
  return intervalData;
}
exports.getWeeklyInterval = getWeeklyInterval;
function convertMinutesTotimezone(minutesCron) {
  var offset = new Date().getTimezoneOffset();
  var minutesOffset = offset % 60;
  var time = minutesCron;
  if (minutesOffset) {
    time = minutesCron.replace(/\d+/ig, function (number) {
      var newNumber = Number(number) + minutesOffset;
      if (newNumber < 0) {
        newNumber = 60 + newNumber;
      }
      if (newNumber > 60) {
        newNumber = newNumber - 60;
      }
      return newNumber;
    });
  }
  return time;
}
exports.convertMinutesTotimezone = convertMinutesTotimezone;
function convertHourToTimezone(hourCron) {
  var offset = new Date().getTimezoneOffset();
  var minutesOffset = offset % 60;
  offset = offset + minutesOffset;
  var time = hourCron.replace(/\d+/ig, function (number) {
    var newNumber = Number(number) * 60 + offset;
    if (newNumber < 0) {
      newNumber = 24 * 60 + newNumber;
    }
    if (newNumber > 24 * 60) {
      newNumber = newNumber - 24 * 60;
    }
    return newNumber / 60;
  });
  return time;
}
exports.convertHourToTimezone = convertHourToTimezone;